/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable unicorn/no-array-reduce */
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'
import { getTerms } from '../../services/useGetTerms'

type OrderDetailsBeforeOrderCalculation = {
  itemsTotal: number
  discounts: number
  subtotal: number
  shipping: number | string
  totalPV: number
  total: number
  taxes: number
}

export const useGetOrderDetailsBeforeOrderCalculation = () => {
  const {
    user: { customerType },
    cart: { otp, subscribe },
    order: { shipMethod },
  } = useGlobalStore()

  const [
    orderDetailsBeforeOrderCalculation,
    setOrderDetailsBeforeOrderCalculation,
  ] = useState<OrderDetailsBeforeOrderCalculation>({
    itemsTotal: 0,
    discounts: 0, // Will be left as 0 for now, until discounts are implemented in CMS
    subtotal: 0,
    shipping: 0,
    totalPV: 0,
    total: 0,
    taxes: 0,
  })

  useEffect(() => {
    const mergedCart = [...otp, ...subscribe]

    const itemsTotalWithoutDiscount = mergedCart.reduce((accumulator, item) => {
      const priceEach = getTerms({
        forCustomerType: 'Customer',
        pricingData: item.product.pricing,
      })?.priceEach

      return accumulator + (priceEach !== undefined ? priceEach * item.qty : 0)
    }, 0)

    const itemsTotalWithDiscounts = mergedCart.reduce((accumulator, item) => {
      const priceEach = getTerms({
        forCustomerType: customerType,
        pricingData: item.product.pricing,
      })?.priceEach

      return accumulator + (priceEach !== undefined ? priceEach * item.qty : 0)
    }, 0)

    const totalPV = mergedCart.reduce((accumulator, item) => {
      const pvEach = getTerms({
        forCustomerType: customerType,
        pricingData: item.product.pricing,
      })?.pvEach

      return accumulator + (pvEach !== undefined ? pvEach * item.qty : 0)
    }, 0)
    // adding this incase we want to display the VAT total in the summary
    const totalTaxes = mergedCart.reduce((accumulator, item) => {
      const tax = getTerms({
        forCustomerType: customerType,
        pricingData: item.product.pricing,
      })?.taxEach

      return (
        accumulator + (tax?.amount !== undefined ? tax.amount * item.qty : 0)
      )
    }, 0)

    const getShippingMethodPrice = () => {
      if (
        !shipMethod ||
        shipMethod?.price === 'error' ||
        shipMethod.price === undefined
      ) {
        return 0
      }

      return Number(shipMethod?.price)
    }

    const subscriptionDiscount =
      subscribe.reduce(
        (accumulator, item) =>
          accumulator + item.subscriptionDiscount * item.qty,
        0,
      ) || 0

    const subtotal = itemsTotalWithDiscounts // subtract discounts and store credit from here
    const total = subtotal + getShippingMethodPrice() - subscriptionDiscount
    const taxes = totalTaxes
    setOrderDetailsBeforeOrderCalculation({
      discounts: subscriptionDiscount,
      itemsTotal: itemsTotalWithoutDiscount,
      subtotal,
      shipping: getShippingMethodPrice() || 0,
      totalPV,
      total,
      taxes,
    })
  }, [
    subscribe,
    otp,
    customerType,
    shipMethod?.price,
    ...otp.map((item) => item.qty).join(','),
    ...subscribe.map((item) => item.qty).join(','),
  ])

  return { orderDetailsBeforeOrderCalculation }
}
